module.exports = __webpack_public_path__ + "static/img/9.4442b23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/9.png
// module id = 9QAl
// module chunks = 0